module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Thin.ed7fd4d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Thin.eot?
// module id = 8cOc
// module chunks = 0